const Profile = () => import("@/components/dashboard/patient/profile/Profile");
const PublicProfile = () =>
  import("@/components/dashboard/patient/profile/PublicProfile");
const PrivateProfile = () =>
  import("@/components/dashboard/patient/profile/PrivateProfile");
const Appointments = () =>
  import("@/components/dashboard/patient/appointments/Appointments");
const Prescriptions = () =>
  import("@/components/dashboard/patient/Prescriptions");
const Tests = () => import("@/components/dashboard/patient/Tests");
const Reports = () => import("@/components/dashboard/patient/Reports");
const Personal = () => import("@/components/dashboard/patient/Personal");
const Contacts = () => import("@/components/dashboard/patient/Contacts");
const Records = () => import("@/components/dashboard/patient/records/Records");
const Gallery = () => import("@/components/dashboard/patient/Gallery");
const consentFormDetailsList = () =>
  import("@/components/dashboard/patient/records/consentFormDetailsList");
const Flag = () => import("@/components/dashboard/patient/Flag/RedFlag");
// const onlineConsultationMain = () =>
//   import(
//     "@/components/dashboard/patient/onlineConsultation/onlineConsultationMain"
//   );
const onlineConsultationMain = () =>
  import(
    "@/components/newOC/patientOC"
  );
const Grievances = () => import("@/components/dashboard/patient/Grievances");
const Accounts = () => import("@/components/dashboard/patient/Accounts");
const MyWallet = () => import("@/components/dashboard/patient/MyWallet");
const Orders = () => import("@/components/Payment/Orders");
const DashboardRating = () =>
  import("@/components/dashboard/patient/DashboardRating");
// const DashboardRating = () =>
//   import("@/components/dashboard/newRatingReview/dashReviews");
const Favourites = () =>
  import("@/components/dashboard/patient/favourites/Favourites");
const Reminders = () => import("@/components/dashboard/patient/Reminders");
const Fitness = () => import("@/components/dashboard/patient/ComingSoon");
const Dependent = () =>
  import("@/components/dashboard/patient/dependents/Dependents");

import PatientAppointmentRoutes from "@/routes/dashboard/PatientAppointments";
// import DashboardRatingRoutes from "@/routes/dashboard/Rating";
const FavouritesDoctor = () =>
  import("@/components/dashboard/patient/favourites/FavouritesDoctor");
  const FavouritesAllied = () =>
  import("@/components/dashboard/patient/favourites/FavouritesAllied");
const FavouritesAmbulance = () =>
  import("@/components/dashboard/patient/favourites/FavouritesAmbulance");
const FavouritesHospital = () =>
  import("@/components/dashboard/patient/favourites/FavouritesHospitalNew");
const FavouritesDiagnostics = () =>
  import("@/components/dashboard/patient/favourites/FavouritesDiagnostics");
const FavouritesPharmacy = () =>
  import("@/components/dashboard/patient/favourites/FavouritesPharmacy");
const FavouritesBloodbank = () =>
  import("@/components/dashboard/patient/favourites/FavouritesBloodbank");
// const myOrders = () =>
//     import ("@/components/dashboard/patient/myOrders/orderList");
const PharmacyOrders = () =>
  import("@/components/dashboard/patient/myOrders/orderList");
const BloodbankOrders = () =>
  import(
    "@/components/dashboard/patient/myOrders/bloodbank/bloodbankOrderList"
  );
import GalleryRoutes from "@/routes/dashboard/Gallery";
import RecordsRoutes from "@/routes/dashboard/Record";
const EnrolledCampaigns = () =>
  import("@/components/dashboard/wallet/enrolledCampaigns/enrolledCampaigns");

const CampaignTransactions = () =>
  import(
    "@/components/dashboard/wallet/enrolledCampaigns/campaignTransactions"
  );
const Dashboard = () => import("@/components/dashboardNew/patientDashboard");

export default [
  {
    path: "",
    name: "dashboard.patient.root",
    redirect: {
      name: "patientDashboard"
    }
  },
  {
    path: "dashboard",
    name: "patientDashboard",
    component: Dashboard
  },
  {
    path: "profile",
    name: "dashboard.patient.profile",
    redirect: {
      name: "dashboard.patient.profile.root"
    },
    component: Profile,

    children: [
      {
        path: "",
        name: "dashboard.patient.profile.root",
        redirect: {
          name: "dashboard.patient.profile.public"
        }
      },
      {
        path: "public",
        name: "dashboard.patient.profile.public",
        component: PublicProfile
      },
      {
        path: "private",
        name: "dashboard.patient.profile.private",
        component: PrivateProfile
      }
    ]
  },
  {
    path: "appointments",
    name: "dashboard.patient.appointments",
    component: Appointments,
    children: PatientAppointmentRoutes
  },
  {
    path: "myOrders/pharmacy/:status?",
    name: "dashboard.patient.myOrders.pharmacy",
    component: PharmacyOrders
  },
  {
    path: "myOrders/bloodbank/:status?",
    name: "dashboard.patient.myOrders.bloodbank",
    component: BloodbankOrders
  },
  {
    path: "prescriptions",
    name: "dashboard.patient.prescriptions",
    component: Prescriptions
  },
  {
    path: "tests",
    name: "dashboard.patient.tests",
    component: Tests
  },
  {
    path: "reports",
    name: "dashboard.patient.reports",
    component: Reports
  },
  {
    path: "personal",
    name: "dashboard.patient.personal",
    component: Personal
  },
  {
    path: "Flag",
    name: "dashboard.patient.Flag",
    component: Flag
  },
  {
    path: "contacts",
    name: "dashboard.patient.contacts",
    component: Contacts
  },
  // {
  //     path: "myOrders/:status?",
  //     name: "dashboard.patient.myOrders.myOrders",
  //     component: myOrders
  // },
  {
    path: "records",
    name: "dashboard.patient.records.records",
    children: RecordsRoutes,
    // redirect: {
    //     name: "dashboard.patient.records.records.consentFormDetailsList"
    // },
    component: Records
  },
  {
    path: "gallery",
    name: "dashboard.patient.gallery",
    children: GalleryRoutes,
    redirect: {
      name: "dashboard.patient.gallery.images"
    },
    component: Gallery
  },
  {
    path: "online-consultation",
    name: "dashboard.patient.onlineConsultation",
    component: onlineConsultationMain
  },
  {
    path: "grievances",
    name: "dashboard.patient.grievances",
    component: Grievances
  },
  {
    path: "medical-accounts",
    name: "dashboard.patient.medicalAccounts",
    component: Accounts
  },
  // {
  //   path: "my-wallet",
  //   name: "dashboard.patient.myWallet",
  //   component: MyWallet
  // },
  {
    path: "my-wallet",
    name: "dashboard.patient.myWallet.walletTransaction",
    component: MyWallet
  },
  {
    path: "wallet/enrolled-campaigns/:status?",
    name: "dashboard.patient.myWallet.enrolledCampaigns",
    component: EnrolledCampaigns
  },

  {
    path: "wallet/campaign-transactions/:status?",
    name: "dashboard.patient.myWallet.campaignTransactions",
    component: CampaignTransactions
  },
  {
    path: "orders",
    name: "dashboard.patient.orders",
    component: Orders
  },

  // {
  //   path: "createEvent",
  //   name: "dashboard.patient.createEvent",
  //   component: createEvent
  // },

  // {
  //   path: "eventDetails/:slug",
  //   name: "dashboard.patient.eventDetails",
  //   component: eventDetails
  // },
  {
    path: "reviews",
    name: "dashboard.patient.reviews",
    // redirect: {
    //   name: "dashboard.reviews.root"
    // },
    component: DashboardRating
    // children: DashboardRatingRoutes
  },
  // {
  //     path: "onlineConsultationMain",
  //     name: "dashboard.patient.onlineConsultation.onlineConsultationMain",

  //     component: onlineConsultationMain

  // },
  {
    path: "favourites",
    name: "dashboard.patient.favourites",
    component: Favourites,
    redirect: {
      name: "dashboard.patient.favourites.doctor"
    },
    children: [
      {
        path: "doctor",
        name: "dashboard.patient.favourites.doctor",
        component: FavouritesDoctor
      },
      {
        path: "allied",
        name: "dashboard.patient.favourites.allied",
        component: FavouritesAllied
      },
      {
        path: "ambulance",
        name: "dashboard.patient.favourites.ambulance",
        component: FavouritesAmbulance
      },
      {
        path: "hospital",
        name: "dashboard.patient.favourites.hospital",
        component: FavouritesHospital
      },
      {
        path: "diagnostics-lab",
        name: "dashboard.patient.favourites.diagnostics-lab",
        component: FavouritesDiagnostics
      },
      {
        path: "pharmacy",
        name: "dashboard.patient.favourites.pharmacy",
        component: FavouritesPharmacy
      },
      {
        path: "bloodbank",
        name: "dashboard.patient.favourites.bloodbank",
        component: FavouritesBloodbank
      }
    ]
  },
  {
    path: "reminders",
    name: "dashboard.patient.reminders",
    component: Reminders
  },
  {
    path: "fitness",
    name: "dashboard.patient.fitness",
    component: Fitness
  },
  {
    path: "dependent",
    name: "dashboard.patient.dependent",
    component: Dependent
  },
  {
    path: "consentFormDetailsList",
    name: "dashboard.patient.records.consentFormDetailsList",
    component: consentFormDetailsList
  }
];
